import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  variant: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}

const ContactInfo = ({ variant, icon, text, url }) => {
  const divClass = 'contact-info'
  if (!url) {
    return (
      <div
        className={variant ? `${divClass} ${divClass}--${variant}` : divClass}
      >
        <img
          className={`${divClass}__icon ${divClass}__icon--${variant}`}
          src={icon}
          alt={variant}
        />
        <span className={variant === 'phone' ? 'text text--number' : 'text'}>
          {text}
        </span>
      </div>
    )
  }

  return (
    <a
      className={variant ? `${divClass} ${divClass}--${variant}` : divClass}
      href={url}
      target="_blank"
    >
      <img
        className={`${divClass}__icon ${divClass}__icon--${variant}`}
        src={icon}
        alt={variant}
      />
      <span className={variant === 'phone' ? 'text text--number' : 'text'}>
        {text}
      </span>
    </a>
  )
}

ContactInfo.propTypes = propTypes

export default ContactInfo



// WEBPACK FOOTER //
// ./src/components/contact/ContactInfo.js